export default {"src":"/_next/static/media/Australia.09b7571d.svg","height":161,"width":289,"blurWidth":0,"blurHeight":0};